import { PolyEditor } from "@evergis/sgis/es/controls/PolyEditor";
import { DomPainter } from "@evergis/sgis/es/painters/DomPainter/DomPainter";
import { Map as SMap } from "@evergis/sgis/es/Map";
import { ControlWithSymbolParams } from "@evergis/sgis/es/controls/Control";
import { SnappingProviderSettings } from "../../../ducks/snapping/types";
import { ServerSnappingController } from "../ServerSnappingController";
import { ServerSnappingProvider } from "../ServerSnappingProvider";

export class BasePolygonEditor extends PolyEditor {
  snappingProvider: ServerSnappingProvider;

  public featureDragAllowed = false;

  private painter: DomPainter;

  private snappingController: ServerSnappingController;

  constructor(map: SMap, painter: DomPainter, params: ControlWithSymbolParams) {
    super(map, params);
    this.painter = painter;

    if (params?.snappingProvider) {
      this.snappingController = new ServerSnappingController({
        map,
        control: this,
        snappingProvider: this.snappingProvider,
        snappingFeature: this._getSnappingFeature(null),
      });
    }
  }

  updateSnappingProvider(snappingProviderSettings: Partial<SnappingProviderSettings>) {
    this.snappingController.updateSnappingProvider(snappingProviderSettings);
  }

  _deactivate() {
    super._deactivate();
    this.snappingController && this.snappingController.deactivate();
  }

  protected _activate() {
    super._activate();
    this.snappingController && this.snappingController.activate();
  }
}
